import { GoBell } from "react-icons/go";
import { Link } from "react-router-dom";
import CustomPopover from "../../../elements/Native/CustomPopover";
import moment from "moment";

const NavtopNotifications = ({ notifications, markNotification }) => {
  const unseenCount = notifications?.filter((n) => !n.isSeen).length || 0;

  return (
    <CustomPopover
      name={
        <button type="button" className="dashboard-topbar__icon relative" aria-label={`Notifications${unseenCount ? `, ${unseenCount} new` : ""}`}>
          <GoBell size={18} />
          {unseenCount > 0 && (
            <span className="absolute top-1 right-1 bg-red-500 w-2 h-2 rounded-full animate-pulse" />
          )}
        </button>
      }
      width="w-80"
    >
      <div className="dashboard-popover">
        {/* Header */}
        <div className="flex items-center justify-between px-4 py-3 border-b border-zinc-100">
          <span className="font-semibold text-zinc-800 text-sm">Notifications</span>
          {unseenCount > 0 && (
            <span className="bg-primary/10 text-primary text-xs font-semibold px-2 py-0.5 rounded-full">
              {unseenCount} new
            </span>
          )}
        </div>

        {/* List */}
        <div className="overflow-y-auto max-h-80">
          {notifications?.length === 0 ? (
            <div className="py-8 text-center text-zinc-400 text-sm">No notifications</div>
          ) : (
            notifications?.map((notification) => (
              <Link
                target="_blank"
                to={
                  notification?.subject === "Shipment Initiated"
                    ? `/admin/order/${notification?.itemId}`
                    : `/order/${notification?.itemId}`
                }
                key={notification._id}
                onClick={() => markNotification(notification)}
              >
                <div
                  className={`flex items-start px-4 py-3 border-b border-zinc-50 hover:bg-zinc-50 transition-colors ${
                    notification.isSeen ? "opacity-60" : ""
                  }`}
                >
                  <div
                    className={`w-8 h-8 rounded-full flex items-center justify-center shrink-0 mr-3 text-xs font-bold ${
                      notification.isSeen
                        ? "bg-zinc-100 text-zinc-400"
                        : "bg-primary/10 text-primary"
                    }`}
                  >
                    {notification.subject?.slice(0, 1) || "N"}
                  </div>
                  <div className="overflow-hidden">
                    <div className="text-sm font-medium text-zinc-700 truncate">
                      {notification.subject}
                    </div>
                    <div className="text-xs text-zinc-400 truncate">{notification.title}</div>
                    <div className="text-xs text-zinc-300 mt-0.5">
                      {moment(notification?.createdAt).fromNow()}
                    </div>
                  </div>
                  {!notification.isSeen && (
                    <div className="w-2 h-2 bg-primary rounded-full shrink-0 mt-2 ml-2" />
                  )}
                </div>
              </Link>
            ))
          )}
        </div>
      </div>
    </CustomPopover>
  );
};

export default NavtopNotifications;
